
import {Component, Vue} from "vue-property-decorator";
import VueSection from "../components/section/index.vue";

@Component({
    components: {
        VueSection
    }
})
export default class HomeClass extends Vue {



    mounted(){
        window.scrollTo(0, 0);
        this.loadMap();
    }


    private loadMap(): void {
        let BMap = (window as any).BMap;
        let map = new (BMap as any).Map("map");
        let point = new (BMap as any).Point(116.671743,40.167739);    //叶青大厦坐标
        map.centerAndZoom(point, 15);
        map.addControl(new (BMap as any).ScaleControl());
        map.addControl(new (BMap as any).NavigationControl());
        this.addMarker(map,point)
        setTimeout(() =>{
            map.panTo(new (BMap as any).Point(116.671743,40.167739));
        }, 2000);
        map.addEventListener("zoomend", function(){
            let ZoomNum = map.getZoom();
            map.centerAndZoom(point, ZoomNum);
        });

        map.disableDragging();     //禁止拖拽.
        // map.setZoomGesturesEnabled(true);
        map.enableScrollWheelZoom();
        map.setMapStyle({style:'grayscale'});
    }



    private addMarker(map: any, point: any){  // 创建图标对象
        let BMap = (window as any).BMap;
        let pic = require("@/assets/imgs/mark.png");
        let myIcon = new (BMap as any).Icon(pic, new (BMap as any).Size(42 * (this as any).$common.getProportion(), 51 * (this as any).$common.getProportion()), {
            backgroundSize: 'cover',
            anchor: new (BMap as any).Size(0, 50 * (this as any).$common.getProportion()),
        });
        // 创建标注对象并添加到地图
        let marker = new (BMap as any).Marker(point, {icon: myIcon});
        map.addOverlay(marker);
    }
}
